module.exports = __webpack_public_path__ + "img/Lakeshore-Hospitals.43455cf3.jpg";